<template>
  <div>
    <div :class="'timeline-badge ' + step.iconColor" data-aos="zoom-in">
      <i :class="step.icon"></i>
    </div>
    <div
      data-class="timeline-panel"
      :id="'timeline-panel' + step.id"
      :class="'timeline-panel step-' + step.id + (step.edit_status === 'saved' ? ' saved' : '')"
      :data-aos="stepIndex % 2 ? 'fade-left' : 'fade-right'"
      data-aos-duration="600"
      :data-status="step.status ? 'true' : 'false'"
    >
      <div class="row">
        <div
          :class="
            'step-wrapper ' +
            (!['details', 'subscribed-contact-through-campaign'].includes(step.activity_type)
              ? 'col-md-7'
              : 'col-md-12')
          "
          :style="
            ['details', 'subscribed-contact-through-campaign'].includes(step.activity_type)
              ? ''
              : 'border-right: 1px solid #EFEFEF;'
          "
        >
          <div class="timeline-heading">
            <h4 class="timeline-title">{{ step.name }}</h4>
          </div>
          <div class="timeline-body">
            <span v-html="description"></span>
          </div>
        </div>
        <div
          v-if="!['details', 'subscribed-contact-through-campaign'].includes(step.activity_type)"
          class="col-md-5 activity-details-wrapper"
        >
          <div v-if="isAdsStepWithoutAdBoost" class="adboost-wrapper">
            <div class="adboost-banner">
              <div class="adboost-facebook">
                <i class="fab fa-facebook"></i>
              </div>
            </div>
            <div class="adboost-ribbon-wrapper">
              <div class="adboost-ribbon">Your ad could be here</div>
            </div>
          </div>
          <div v-else :style="{backgroundImage: 'url(' + step.thumbnail + ')'}"></div>
        </div>
        <div class="step-completed-container">
          <i
            :class="'fas fa-check-circle fa-lg pull-right step-completed step-enabled step-enabled-' + step.id"
            aria-hidden="true"
          ></i>
          <i
            :class="'fas fa-times-circle fa-lg pull-right step-completed step-disabled step-disabled-' + step.id"
            aria-hidden="true"
          ></i>
        </div>
      </div>
      <div v-if="!isAdsStepWithoutAdBoost" class="row">
        <div class="col-md-12 timeline-button-wrapper">
          <div class="btn-row">
            <div>
              <span v-if="step.activity_type === 'information'">
                <button class="btn btn-primary" @click="onPreviewClick"><i class="glyphicon glyphicon-eye-open"></i> Preview</button>
              </span>
              <span
                v-else-if="isTextsStepWithoutConvos"
                v-tooltip="'Editing is disabled because you do not have an active Convos subscription.'"
              >
                <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-pencil s"></i> Edit</button>
              </span>
              <span
                v-else-if="isTextsStepWithoutPhone"
                v-tooltip="'Editing is disabled because your phone number has not yet been activated.'"
              >
                <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-pencil s"></i> Edit</button>
              </span>

              <span
                  v-tooltip="'Editing is disabled since details step was already saved.'"
                  v-else-if="!this.isBeforeFirstDetailsStep && this.step.activity_type === 'details' && !this.hasUnsavedDetailsSteps"
              >
                <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-pencil s"></i> Edit</button>
              </span>
              <span
                  v-tooltip="this.nonDetailStepsWithUnsavedDetailStepTooltip"
                  v-else-if="!this.isBeforeFirstDetailsStep && this.step.activity_type !== 'details' && this.hasUnsavedDetailsSteps"
              >
                <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-pencil s"></i> Edit</button>
              </span>

              <span
                  v-tooltip="'Editing is disabled since this campaign has been launched.'"
                  v-else-if="campaign.lockChangedCampaigns && campaign.active"
              >
                <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-pencil s"></i> Edit</button>
              </span>
              <button
                v-else-if="
                  !campaign.lockChangedCampaigns ||
                  (campaign.lockChangedCampaigns && campaign.state !== 'locked')
                "
                @click="onEditClick"
                class="btn btn-primary"
              >
                <i class="glyphicon glyphicon-pencil s"></i> Edit
              </button>
              <span v-else v-tooltip="'Editing is disabled until compliance reviews this campaign.'">
                <button class="btn btn-primary" disabled><i class="glyphicon glyphicon-pencil s"></i> Edit</button>
              </span>
              <step-preview-button
                v-if="step.activity_type !== 'information'"
                :activity-type="step.activity_type"
                :edit-status="editStatus"
                :step-id="step.id"
                @open-preview="onPreviewClick"
              ></step-preview-button>
            </div>
            <div v-if="step.activity_type !== 'information'">
              <step-share-dropdown
                v-if="step.is_shareable"
                :campaign="campaign"
                :edit-status="editStatus"
                :step="step"
                :timezone="timezone"
              ></step-share-dropdown>
              <step-email-test-dropdown
                v-if="step.activity_type === 'emails' || step.activity_type === 'scheduled-email'"
                :campaign="campaign"
                :step="step"
                :user="user"
              ></step-email-test-dropdown>
              <div v-if="!['details', 'pages', 'script'].includes(step.activity_type)" class="btn-group ml-3">
                <button
                  v-if="step.activity_type === 'delayed-messages' && step.delay === 9999"
                  class="btn btn-delay"
                  v-tooltip.bottom="'Sent immediately upon registration'"
                >
                  <small><i class="glyphicon glyphicon-time"></i> Sent immediately upon registration</small>
                </button>

                <button
                  v-else-if="step.activity_type === 'delayed-messages' && step.delay === 0"
                  class="btn btn-delay"
                  v-tooltip.bottom="'Sent at event time'"
                >
                  <small><i class="glyphicon glyphicon-time"></i> Sent at event time</small>
                </button>

                <button
                  v-else-if="step.activity_type === 'delayed-messages' && step.delay < 24"
                  class="btn btn-delay"
                  v-tooltip.bottom="
                    'Sent ' + step.delay + ' ' + (step.delay == 1 ? ' Hour' : ' Hours') + ' Before Event'
                  "
                >
                  <small
                    ><i class="glyphicon glyphicon-time"></i> {{ step.delay }}
                    {{ step.delay == 1 ? ' Hour Before Event' : ' Hours Before Event' }}</small
                  >
                </button>

                <button
                  v-else-if="step.activity_type === 'delayed-messages' && step.delay >= 24"
                  class="btn btn-delay"
                  v-tooltip.bottom="
                    'Sent ' + step.delay / 24 + ' ' + (step.delay / 24 == 1 ? ' Day' : ' Days') + ' Before Event'
                  "
                >
                  <small
                    ><i class="glyphicon glyphicon-time"></i> {{ step.delay / 24 }}
                    {{ step.delay / 24 == 1 ? ' Day Before Event' : ' Days Before Event' }}</small
                  >
                </button>

                <button
                  v-else-if="step.activity_type === 'scheduled-email' && stepLaunchIsDate && step.launch"
                  class="btn btn-delay"
                  v-tooltip.bottom="'Sent ' + calculatedStepLaunchDate"
                >
                  <small><i class="glyphicon glyphicon-time"></i> {{ calculatedStepLaunchDate }} </small>
                </button>

                <button v-else class="btn btn-delay" v-tooltip.bottom="delayButtonTooltip">
                  <small> <i class="glyphicon glyphicon-time"></i> {{ delayButtonText }} </small>
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="
              step.activity_type === 'documents' && campaign.lockChangedCampaigns && campaign.state !== 'locked'
            "
          >
            <small>Note: This step requires submitting to compliance</small>
          </div>
        </div>
      </div>
    </div>
    <edit-step
      :admin-bar-shown="adminBarShown"
      :campaign="campaign"
      :advanced-email-options="campaign.advancedEmailOptions"
      :step-id="step.id"
      :step-name="step.name"
      :step-index="stepIndex"
      :step-description="step.description"
      :step-activity-type="step.activity_type"
      :step-status="step.status"
      :modal-id="editModalId"
      :modal-shown="editModalShown && !isSocial"
      :first-step-id="firstStepId"
      @close-modal="onCloseModal"
      @step-completed="onStepCompleted"
      :show-form-submission-notifications="showFormSubmissionNotifications"
      :form-submission-notifications-title="formSubmissionNotificationsTitle"
      :form-submission-notifications-description="formSubmissionNotificationsDescription"
    >
    </edit-step>
    <step-preview-modal
      :key="step.id"
      :activity-type="step.activity_type"
      :campaign-id="campaign.id"
      :modal-id="previewModalId"
      :modal-shown="previewModalShown"
      :step-id="step.id"
      :vessel-id="vesselId"
      @close-modal="onCloseModal"
    >
    </step-preview-modal>
    <social-step-editor
      v-if="socialModalOpen"
      :step-status="status"
      :date="calculatedStepLaunchDate"
      :campaign="campaign"
      :step="step"
      :activity-type="step.activity_type"
      :style="buildersStyles"
      class="step-editor-wrapper"
      @close="
        socialModalOpen = false;
        removeModalFromUrl();
      "
      @step-completed="onStepCompleted"
    ></social-step-editor>
    <email-step-editor
      v-if="emailModalOpen"
      :step-status="status"
      :campaign="campaign"
      :step="step"
      :user="user"
      :style="buildersStyles"
      class="step-editor-wrapper"
      @exit="
        emailModalOpen = false;
        removeModalFromUrl();
      "
      @step-completed="onStepCompleted"
    ></email-step-editor>

    <landing-step-editor
      v-if="landingModalOpen"
      :step-status="status"
      :campaign="campaign"
      :step="step"
      :user="user"
      :style="buildersStyles"
      class="step-editor-wrapper"
      @exit="
        landingModalOpen = false;
        removeModalFromUrl();
      "
      @step-completed="onStepCompleted"
    ></landing-step-editor>
  </div>
</template>

<script>
import EditStep from './EditStep';
import StepPreviewButton from './campaign/edit/StepPreviewButton';
import StepPreviewModal from './campaign/edit/StepPreviewModal';
import StepShareDropdown from './campaign/edit/StepShareDropdown';
import StepEmailTestDropdown from './campaign/edit/StepEmailTestDropdown';
import {convertServerDateToLocalMoment} from '../utility/date/date-converter';
import SocialStepEditor from './campaign/edit/social/SocialStepEditor';
import EmailStepEditor from './campaign/edit/email/EmailStepEditor';
import LandingStepEditor from './campaign/edit/landing/LandingStepEditor';
import {SocialPostTypes} from './campaign/edit/social/SocialPostTypes.js';
import VTooltip from 'v-tooltip';

export default {
  name: 'campaign-step',
  components: {
    EditStep,
    StepEmailTestDropdown,
    StepPreviewButton,
    StepPreviewModal,
    StepShareDropdown,
    SocialStepEditor,
    EmailStepEditor,
    LandingStepEditor,
    VTooltip
  },
  data() {
    return {
      pieces: [],
      editModalShown: false,
      editStatus: '',
      previewModalShown: false,
      socialModalOpen: false,
      emailModalOpen: false,
      landingModalOpen: false,
      builderTypes: {
        Email: 'unlayer_email',
        Landing: 'unlayer_web',
      },
      status: false,
    };
  },
  props: {
    adBoostSalesMessage: {
      type: String,
      required: true,
    },
    advertisingPlanActive: {
      type: Boolean,
      required: true,
    },
    adminBarShown: {
      type: Boolean,
      required: false,
    },
    campaign: {
      type: Object,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    step: {
      type: Object,
      required: true,
    },
    stepIndex: {
      type: Number,
      required: true,
    },
    me: {
      type: Object,
    },
    user: {
      type: Object,
      required: true,
    },
    vesselId: {
      type: String,
      required: true,
    },
    firstStepId: {
      type: Number,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    showFormSubmissionNotifications: {
      type: Boolean,
      required: true,
    },
    formSubmissionNotificationsTitle: {
      type: String,
      required: true,
    },
    formSubmissionNotificationsDescription: {
      type: String,
      required: true,
    },
  },
  computed: {
    isBeforeFirstDetailsStep() {
      let details_steps = this.steps.filter(function(step) {
        return step.activity_type === 'details';
      });

      if (details_steps.length === 0) {
        return false;
      }

      return this.steps.findIndex((step) => step.id === this.step.id) < this.steps.findIndex((step) => step.id ===  details_steps[0].id);
    },
    unsavedDetailsSteps() {
      return this.steps.filter(function(step) {
        return step.activity_type === 'details' && step.edit_status_tooltip_control !== 'saved'
      });
    },
    hasUnsavedDetailsSteps() {
      return this.unsavedDetailsSteps.length !== 0;
    },
    nonDetailStepsWithUnsavedDetailStepTooltip() {
      return this.hasUnsavedDetailsSteps
          ? 'Please first edit this step: ' + this.unsavedDetailsSteps[0].name
          : '';
    },
    adBoostMessage() {
      if (this.adBoostSalesMessage && String(this.adBoostSalesMessage).trim().length > 0) {
        return this.adBoostSalesMessage;
      }

      return `Optional: Grow your audience and generate fresh leads with targeted digital advertising. These ads are
              disabled and you will not be charged unless you enroll in our AdBoost program.
              <a href="/library/type/services/online-advertising/" target="_blank">Sign up now</a> or
              <a href="/library/goal/training/weekly-advertising-workshops/" target="_blank">
              have your questions answered by attending an advertising workshop</a>.
      `;
    },
    delayDays() {
      if (!this.step.delay && this.step.delay_hours) {
        return '';
      }

      const days = Math.abs(this.step.delay);
      return `${days} ${days === 1 ? 'Day' : 'Days'}`;
    },
    delayHours() {
      if (!this.step.delay_hours) {
        return '';
      }

      const hours = Math.abs(this.step.delay_hours);
      return `${hours} ${hours === 1 ? 'Hour' : 'Hours'}`;
    },
    delayTime() {
      if (!this.step.delay_time && this.step.delay_time !== 0) {
        return '';
      }

      return moment(this.step.delay_time, 'HH').format('ha');
    },
    delayButtonText() {
      let delay = this.delayDays;
      if (this.delayHours) {
        delay += ` ${this.delayHours}`;
      }
      if (this.delayTime) {
        delay += ` at ${this.delayTime}`;
      }

      const suffix = Math.sign(this.step.delay) < 0 ? 'Before' : '';

      return suffix ? `${delay} ${suffix}` : delay;
    },
    delayButtonTooltip() {
      const delay = [this.delayDays, this.delayHours].filter(Boolean).join(' and ');

      const suffix = Math.sign(this.step.delay) < 0 ? 'Before' : 'From Start';

      if (!this.delayTime) {
        return `Sent ${delay} ${suffix}`;
      }

      return `Sent at ${this.delayTime} but no sooner than ${delay} ${suffix}`;
    },
    description() {
      if (this.isAdsStepWithoutAdBoost) {
        return this.adBoostMessage;
      }
      if (this.step.activity_type === 'texts' && !this.me?.is_convos_active) {
        return `Optional: Build stronger connections, way faster — via text message. These texts are disabled and you will not be charged unless you have a subscription to Convos. <a href="/library/add-ons/convos/" target="_blank">Sign up now</a>`;
      }
      if (this.step.activity_type === 'texts' && !this.me?.is_convos_phone_active) {
        return `We see that you are subscribed to Convos, but your phone number has not yet been activated. Once it has been activated, you will have access to this text message.`;
      }

      return this.step.description;
    },
    editModalId() {
      return `step-edit-${this.step.id}`;
    },
    previewModalId() {
      return `step-preview-${this.step.id}`;
    },
    isAdsStepWithoutAdBoost() {
      return this.step.activity_type === 'ads' && !this.advertisingPlanActive;
    },
    isTextsStepWithoutConvos() {
      return this.step.activity_type === 'texts' && !this.me?.is_convos_active;
    },
    isTextsStepWithoutPhone() {
      return this.step.activity_type === 'texts' && !this.me?.is_convos_phone_active;
    },
    stepLaunchIsDate() {
      var date = moment(this.step.launch);

      if (date.isValid()) {
        return true;
      }

      return false;
    },
    calculatedStepLaunchDate() {
      var date = moment(this.step.launch);

      if (date.isValid() && (Math.sign(this.step.delay) == 0 || Math.sign(this.step.delay) == 1)) {
        return convertServerDateToLocalMoment(this.step.launch, 'YYYY-MM-DD HH:mm:ss', this.timezone)
          .add(Math.abs(this.step.delay), 'days')
          .format('MMMM Do YYYY, h:mm:ss a');
      } else if (date.isValid() && Math.sign(this.step.delay) == -1) {
        return convertServerDateToLocalMoment(this.step.launch, 'YYYY-MM-DD HH:mm:ss', this.timezone)
          .subtract(Math.abs(this.step.delay), 'days')
          .format('MMMM Do YYYY, h:mm:ss a');
      }

      return this.step.delay;
    },
    isSocial() {
      return Object.values(SocialPostTypes).includes(this.step.activity_type);
    },
    isEmail() {
      return ['emails', 'scheduled-email'].includes(this.step.activity_type);
    },
    isPage() {
      return this.step.activity_type === 'pages';
    },
    isBuilder() {
      return this.isSocial || this.isUnlayerEmail || this.isUnlayerLanding;
    },
    isUnlayerLanding() {
      return this.isPage && this.step.is_unlayer_builder;
    },
    isUnlayerEmail() {
      return this.isEmail && this.step.is_unlayer_builder;
    },
    buildersStyles() {
      const margin = (this.adminBarShown ? 32 : 0) + 'px';
      return {
        height: `calc(100vh - ${margin}`,
        marginTop: margin,
      };
    },
  },
  watch: {
    step: {
      immediate: true,
      handler(step) {
        this.editStatus = step.edit_status || 'null';
      },
    },
  },
  methods: {
    onStepCompleted() {
      this.editStatus = 'saved';
      this.$emit('step-completed');
      this.$emit('step-completed-and-saved');
    },
    onEditClick() {
      this.addModalToUrl(this.editModalId);
      this.openEditModal();
    },
    onPreviewClick() {
      this.addModalToUrl(this.previewModalId);
      this.openPreviewModal();
    },
    onCloseModal() {
      this.removeModalFromUrl();
    },

    async openEditModal() {
      let panel = document.getElementById('timeline-panel' + this.step.id);
      this.status = panel.getAttribute('data-status') === 'true' ? true : false;

      if (this.isSocial) {
        this.socialModalOpen = true;
        return;
      }

      if (this.isUnlayerEmail) {
        this.emailModalOpen = true;
        return;
      }

      if (this.isUnlayerLanding) {
        this.landingModalOpen = true;
        return;
      }

      this.editModalShown = true;
    },
    openPreviewModal() {
      this.previewModalShown = true;
    },
    openModal(modalId) {
      if (modalId === this.editModalId) {
        this.openEditModal();
      } else if (modalId === this.previewModalId) {
        this.openPreviewModal();
      }
    },
    closeModals() {
      this.editModalShown = false;
      this.previewModalShown = false;
      this.socialModalOpen = false;
    },
    addModalToUrl(modalId) {
      const searchParams = new URLSearchParams(window.location.search.slice(1));
      searchParams.set('modal', btoa(modalId));
      const url = `?${searchParams.toString()}`;
      window.history.pushState(undefined, undefined, url);
    },
    removeModalFromUrl() {
      const searchParams = new URLSearchParams(window.location.search.slice(1));
      if (searchParams.has('modal')) {
        searchParams.delete('modal');
        const url = `?${searchParams.toString()}`;
        window.history.pushState({}, '', url);
        window.dispatchEvent(new Event('popstate'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.timeline-panel {
  z-index: 101;
}

.btn-row {
  display: flex;
  justify-content: space-between;

  & > * {
    display: flex;
  }
}

.adboost-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.adboost-banner {
  border: 1px solid #000000;
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: center;
  margin: 0;
  position: relative;
  width: 100%;

  &::before {
    content: '';
    display: inline-block;
    width: 1px;
    height: 0;
    padding-bottom: 55%;
  }
}

.adboost-facebook {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0;
  position: absolute;
  width: 100%;

  & > .fab {
    color: #1877f2;
    font-size: 75px;
    position: absolute;
  }
}

$adboost-ribbon-height: 32px;

.adboost-ribbon-wrapper {
  position: absolute;
  left: 3px;
  top: 42%;
  transform: rotate(-10deg);
  height: $adboost-ribbon-height;
  margin: 0;
  width: calc(100% - 11px);
}

.adboost-ribbon {
  background-color: #595b61;
  color: #ffffff;
  font-weight: bold;
  height: $adboost-ribbon-height;
  line-height: $adboost-ribbon-height;
  margin: 0;
  width: 100%;

  &::before,
  &::after {
    content: '';
    position: absolute;
    display: block;
    border-style: solid;
    z-index: -1;
    transform: rotate(10deg);
  }

  &::before {
    border-color: transparent #43454b transparent transparent;
    border-width: 8px 8px 4px 0;
    bottom: -5px;
    left: 0px;
  }

  &::after {
    border-color: #43454b transparent transparent transparent;
    border-width: 8px 8px 0 0;
    bottom: -7px;
    right: 1px;
  }
}

.step-editor-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  width: 100vw;
  z-index: 1050;
}
</style>
